import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";
import { axios_instance } from "../../../../api/axios_instance";

const TrancheControlModal = ({
  disbursement_id,
  pay_count,
  closeTrancheControlModal,
}) => {
  const initialState = { reasons: [] };
  const [state, setState] = useState(initialState);
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeTrancheControlModal);
  }, [closeTrancheControlModal]);

  const fetchReasons = useCallback(async () => {
    try {
      const reasonsResp = await axios_instance({
        url: "/dts/getTrancheControlReasons",
        method: "POST",
        data: {
          disbursement_id,
          pay_count,
        },
      });
      setState((prevState) => ({
        ...prevState,
        reasons: reasonsResp.data.result,
      }));
    } catch (error) {}
  }, [disbursement_id, pay_count]);

  useEffect(() => {
    fetchReasons();
  }, [fetchReasons]);

  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="trancheControl-modal-content" ref={ref}>
        <div className="modal-header">
          <button
            type="button"
            className="close"
            onClick={closeTrancheControlModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 className="modal-title" id="">
            Risk Reasons
          </h4>
        </div>
        <div className="modal-body clearfix">
          <ul className="ul-control-reason mar-L15">
            {state.reasons.map((res, idx) => {
              return <li key={idx}>{res.control_reason}</li>;
            })}
          </ul>
        </div>
        <div className="modal-footer text-center">
          <button
            type="button"
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeTrancheControlModal}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default TrancheControlModal;
